export * from "./BankSelector.component";
export const LIST_OF_BANKS: [
  string,
  string
][] = require("./list_of_banks.json");
